// ======================================================================
// File Name       : initialImage
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const INIT_INITIAL_IMAGE = 'INIT_INITIAL_IMAGE';
export const INITIAL_IMAGE_LIST = 'INITIAL_IMAGE_LIST';
